<script setup lang="ts">
defineProps({
    blok: Object,
})

const { state } = useHomeStore()
</script>

<template>
    <div>
        <UiContainer>
            <div class="flex gap-x-3.5 justify-center max-[769px]:w-full max-[769px]:items-center max-[769px]:inline-flex max-[769px]:gap-y-1 max-[769px]:flex-col">
                <UButton
                    v-for="item in blok"
                    :key="item._uid"
                    :label="item?.label"
                    :variant="state.type == item?.id ? 'solid' : 'outline'"
                    @click="state.type = item?.id"
                />
            </div>
        </UiContainer>
        <UiContainer>
            <template
                v-for="item in blok"
                :key="item.id"
            >
                <HomeRank
                    v-if="item?.id == state.type"
                    :blok="item"
                />
            </template>
        </UiContainer>
    </div>
</template>
